// Generated by CoffeeScript 1.12.7
(function () {
  var LinksVisualization;

  module.exports = LinksVisualization = (function () {
    function LinksVisualization(createUi, eventData) {
      this.ui = createUi(require("Analytics/Visualizations/Links/Links.html"), {
        links: [],
        loaded: false,
      });
      eventData.getLinkClicks().then(
        (function (_this) {
          return function (links) {
            _this.ui.links = links;
            return (_this.ui.loaded = true);
          };
        })(this),
      );
    }

    return LinksVisualization;
  })();
}.call(this));
